<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <div class="col-xs-12 mycol">
      <textarea
        :disabled="
          $parent.$parent.projectDisabled ||
            $parent.$parent.project.UF_IS_BLOCK === 1
        "
        type="text"
        class="i-main-style t-co-executor-style t-dop-style"
        style="min-width: 600px;"
        v-model="$parent.project.UF_PLACE_INDUSTRIAL_EQUIPMENT"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "uf_place_industrial_equipment",
  methods: {}
};
</script>

<style scoped></style>
